<form [formGroup]="childForm">
  <page-alert message="Endereço Atualizado com sucesso!" *ngIf="showSuccessMessage"
    alertClass="alert-success"></page-alert>
  <page-alert message="Falha ao atualizar endereço" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <div class="col-xs-12">
    <div class="col-xs-8 col-md-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>CEP</mat-label>
        <input type="text" matInput required formControlName="cep" mask="00000-000" placeholder="CEP" />
      </mat-form-field>

      <mat-error *ngIf="childForm.get('cep')?.hasError('required') &&  childForm.get('cep')?.touched"> Campo obrigatório
      </mat-error>
      <mat-error *ngIf="cepError &&  childForm.get('cep')?.touched"> Nenhum endereço foi encontrado para este CEP.
        Verifique se está correto ou tente outro.</mat-error>
      <mat-error *ngIf="childForm.get('cep')?.hasError('pattern') && childForm.get('cep')?.touched"> Formato Inválido
      </mat-error>
    </div>
    <div class="col-xs-2 col-md-2">
      <button mat-flat-button color="primary" (click)="searchAddressByCep()"
        [disabled]="submittedCep" class="formBt">Buscar</button>
    </div>

  </div>

  <div class="col-xs-12 col-md-12">
    <mat-card class="google-maps">
      <div class="row">
        <div class="col-xs-12 col-sm-6">

          <div class="col-xs-12 ">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>País</mat-label>
              <input type="text" matInput formControlName="country" placeholder="País"
                (keypress)="allowOnlyLetters($event)">
              <mat-error *ngIf="childForm.get('country')?.hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="col-xs-12 ">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Estado</mat-label>
              <input type="text" matInput formControlName="state" placeholder="Estado"
                (keypress)="allowOnlyLetters($event)">
              <mat-error *ngIf="childForm.get('state')?.hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="col-xs-12 ">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Cidade</mat-label>
              <input type="text" matInput formControlName="city" placeholder="Cidade"
                (keypress)="allowOnlyLetters($event)">
              <mat-error *ngIf="childForm.get('city')?.hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="col-xs-12 ">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Logradouro</mat-label>
              <input type="text" matInput formControlName="street" placeholder="Logradouro"
               >
              <mat-error *ngIf="childForm.get('street')?.hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="col-xs-12 col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Número</mat-label>
              <input type="text" matInput formControlName="number" placeholder="Número"
               >
              <mat-error *ngIf="childForm.get('number')?.hasError('required')">Campo obrigatório</mat-error>
            </mat-form-field>
          </div>

          <div class="col-xs-12 col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Complemento</mat-label>
              <input type="text" matInput formControlName="complement" placeholder="Complemento"
                >

            </mat-form-field>
          </div>


        </div>
      </div>
    </mat-card>

    <div class="col-xs-12 actions">
      <button mat-raised-button color="primary" (click)="save()" type="submit"
        [disabled]="loading || cepError || childForm.invalid">
        <ng-container *ngIf="!loading">Salvar endereço</ng-container>
        <ng-container *ngIf="loading">
          <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
        </ng-container>
      </button>
    </div>
  </div>
</form>